// Mapeamento de tipos de notificação para arquivos de som
const notificationSounds: Record<string, string> = {
  pix_confirmed: '/sounds/apple-pay-check.mp3',
  payment_received: '/sounds/coin-drop.mp3',
  sale_created: '/sounds/cash-register.mp3',
  default: '/sounds/notification.mp3',
};

// Cache de objetos Audio para evitar recarregar
const audioCache: Record<string, HTMLAudioElement> = {};

// Pré-carregar sons para resposta instantânea
export const preloadNotificationSounds = () => {
  const uniqueSounds = [...new Set(Object.values(notificationSounds))];
  
  uniqueSounds.forEach(soundPath => {
    if (!audioCache[soundPath]) {
      try {
        const audio = new Audio(soundPath);
        audio.preload = 'auto';
        audio.load();
        audioCache[soundPath] = audio;
      } catch (error) {
        console.warn('Erro ao pré-carregar som:', soundPath, error);
      }
    }
  });
};

// Verificar se som está habilitado (padrão: true)
const isSoundEnabled = (): boolean => {
  const soundEnabled = localStorage.getItem('notification_sound_enabled');
  return soundEnabled !== 'false';
};

// Tocar som baseado no tipo de notificação
export const playNotificationSound = (
  notificationType: string, 
  volume: number = 0.5
) => {
  if (!isSoundEnabled()) return;
  
  const soundPath = notificationSounds[notificationType] || notificationSounds.default;
  
  try {
    // Usar cache ou criar novo
    let audio = audioCache[soundPath];
    if (!audio) {
      audio = new Audio(soundPath);
      audioCache[soundPath] = audio;
    }
    
    // Clonar para permitir múltiplas reproduções simultâneas
    const audioClone = audio.cloneNode() as HTMLAudioElement;
    audioClone.volume = volume;
    audioClone.play().catch(() => {
      // Silenciosamente falhar se autoplay bloqueado
    });
  } catch (error) {
    console.warn('Erro ao tocar som de notificação:', error);
  }
};

// Tocar som específico de Pix (volume mais alto para destaque)
export const playPixConfirmedSound = () => {
  playNotificationSound('pix_confirmed', 0.7);
};

// 🔊 Tocar som de caixa registradora (Cha-Ching!) ao finalizar venda
export const playCashRegisterSound = () => {
  playNotificationSound('sale_created', 0.5);
};

// Toggle para habilitar/desabilitar sons
export const setNotificationSoundEnabled = (enabled: boolean) => {
  localStorage.setItem('notification_sound_enabled', enabled ? 'true' : 'false');
};

// Verificar estado atual
export const getNotificationSoundEnabled = (): boolean => {
  return isSoundEnabled();
};
